import { Link } from 'react-router-dom';
import { hotMovies } from '@/mocks/movies';

export default function FeaturedMovies() {
  return (
    <section className="py-12 md:py-16" data-product-shop>
      <div className="px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-center justify-between mb-8">
            <div>
              <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-50">
                热门推荐
              </h2>
              <p className="text-sm text-foreground-600 mt-1">大家都在看的高清大片</p>
            </div>
            <Link
              to="/category/all"
              className="flex items-center gap-1 text-sm text-primary-500 hover:text-primary-400 transition-colors duration-200 cursor-pointer whitespace-nowrap"
            >
              查看全部
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line"></i>
              </div>
            </Link>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 md:gap-5">
            {hotMovies.map((movie) => (
              <Link
                key={movie.id}
                to={`/article/${movie.id}`}
                className="group cursor-pointer"
              >
                <div className="relative aspect-[2/3] rounded-lg overflow-hidden mb-3">
                  <img
                    src={movie.posterUrl}
                    alt={movie.title}
                    title={`${movie.title} - 天堂影院高清在线观看`}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-background-50 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                  {/* Rating */}
                  <div className="absolute top-2 right-2 bg-background-50/90 backdrop-blur-sm px-2 py-0.5 rounded text-xs font-semibold text-primary-500">
                    {movie.rating}
                  </div>
                  {/* Play overlay */}
                  <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-500/90">
                      <i className="ri-play-fill text-foreground-50 text-xl"></i>
                    </div>
                  </div>
                </div>
                <h3 className="text-sm font-medium text-foreground-200 group-hover:text-primary-500 transition-colors duration-200 truncate">
                  {movie.title}
                </h3>
                <p className="text-xs text-foreground-600 mt-0.5">
                  {movie.year} · {movie.category}
                </p>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}